import React, { useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton, Dropdown } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';

import { useStyles } from '../styles/select-billing-group-dialog';

export const SelectBillingGroupDialog = ({
  onConfirm,
  onDecline,
  billingGroups,
  hidden,
  isLoading,
}) => {
  const i18n = useContext(I18nContext);
  const styles = useStyles();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const dialogContentProps = {
    type: DialogType.normal,
    title: i18n.getString(_TL_('Add account to billing group')),
    closeButtonAriaLabel: 'Close',
  };
  const modalProps = {
    isBlocking: true,
    className: classNames('add-to-billing-group-dialog', styles.dialog),
  };
  const options = useMemo(() => billingGroups.map(item => ({ key: item.id, text: item.name })), [billingGroups]);
  const onDialogConfirm = () => {
    onConfirm(selectedGroup);
  };
  const onSelectionChange = (_, item) => {
    setSelectedGroup(item);
    setIsDisabled(false);
  };

  return (
    <Dialog
      onDismiss={onDecline}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      hidden={hidden}
    >
      <UiBlocker
        blocking={isLoading}
        loadingText={i18n.getString(_TL_('Loading...'))}
        classes={{
          blockUiContainer: 'blocker-global',
          blockerIndicator: 'blocker-indicator',
        }}
      >
        <Dropdown
          label="Select a billing group"
          selectedKey={selectedGroup ? selectedGroup.key : undefined}
          onChange={onSelectionChange}
          placeholder="Select an option"
          options={options}
          className="add-to-billing-group-dialog-dropdown"
        />
        <DialogFooter>
          <PrimaryButton className="confirm-button" disabled={isDisabled || isLoading} onClick={onDialogConfirm} text={i18n.getString(_TL_('Add to billing group'))} />
          <DefaultButton className="decline-button" onClick={onDecline} text={i18n.getString(_TL_('Cancel'))} />
        </DialogFooter>
      </UiBlocker>
    </Dialog>
  );
};

SelectBillingGroupDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  billingGroups: PropTypes.array.isRequired,
  hidden: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
SelectBillingGroupDialog.defaultProps = {
};
